import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/SchoolProgram/2024/orientation/1.jpg';
// import p2 from 'assests/Photos/SchoolProgram/2024/orientation/2.jpg';
// import p3 from 'assests/Photos/SchoolProgram/2024/orientation/3.jpg';
// import p4 from 'assests/Photos/SchoolProgram/2024/orientation/4.jpg';
// import p5 from 'assests/Photos/SchoolProgram/2024/orientation/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2024/orientation/6.jpg';


// import p5 from 'assests/Photos/SchoolProgram/2023/Valediction_ceremony/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2023/RepublicDay/6.jpg';
// import p7 from 'assests/Photos/SchoolProgram/2023/RepublicDay/7.jpg';
// import p8 from 'assests/Photos/SchoolProgram/2023/RepublicDay/8.jpg';
// import p9 from 'assests/Photos/SchoolProgram/2023/RepublicDay/9.jpg';
// import p10 from 'assests/Photos/SchoolProgram/2023/RepublicDay/10.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const Orientation2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/orientation/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/orientation/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/orientation/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/orientation/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/school-programs/orientation/5.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/school-programs/orientation/6.webp`;
    const p7 = `${config.base_image_url_2025}/home/events-activities/school-programs/orientation/7.webp`;
    const p8 = `${config.base_image_url_2025}/home/events-activities/school-programs/orientation/8.webp`;
   
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
          {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        }, 
      {
          src: p7,
          source: p7,
          rows: 1,
          cols: 1,
      },
      {
          src: p8,
          source: p8,
          rows: 1,
          cols: 1,
      }, 

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                Parent Orientation day	
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Class: MONTESSORI- CLASS 12    Date: 30 MAY 2025
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The Orientation Session for the academic year 2025–26, for all the classes was led by our Principal Ms Sheeja Manoj and the followed by the respective segment Assistant Principal/COD. This session served as a vital starting point for both parents and students, offering a clear overview of what lies ahead. It outlined the school’s expectations in terms of academic discipline, attendance, behaviour and parental involvement. The Principal also discussed the consequences of not meeting these expectations, emphasising the importance of a supportive and structured environment to ensure every student’s success.  
                                    <br></br>
                                   <b>The Pre-Primary (Montessori and Kindergarten):</b> The orientation sessions for new and existing parents were held on 24th and 30th May 2025 respectively, introducing the two early childhood streams—Montessori and Kindergarten. The sessions emphasised the school’s commitment to inquiry-based and holistic learning. The key topics included curriculum structure, assessment methods, developmental milestones and daily routines. Parents were also informed about effective school-home communication practices. The sessions also highlighted the importance of fostering a nurturing, engaging environment both at home and in school, to support each child’s overall growth and well-being.<br></br>

                                    <b>Primary School (Classes 1-5):</b> Orientation Session for Classes 1 to 5 were held on 28/05/2025 & 29/05/2025 wherein the Principal briefed the parents on the school policies, curriculum, assessment pattern and Co-Curricular activities followed at NPS Yeshwanthpur. A significant inclusion in this year’s curriculum for the holistic development of students is the introduction of vocational class and the introduction of an additional language.<br></br>

                                     <b>Middle School (Classes 6-8):</b> The orientation sessions held on 24th and 27th May 2025 effectively briefed parents on the academic year 2025–26. The school highlighted its preparedness, curriculum structure, assessment methods and introduction of the three-language formula in concurrence with the NEP guidelines. Key academic expectations and support systems were clearly explained. Parents were also informed about extracurricular activities and daily schedules. Most queries were addressed, ensuring clarity and confidence. The session was informative, well-structured and appreciated by the attendees.<br></br>

                                     <b>Secondary School (Classes 9 and 10):</b> The orientation session was held on Friday, 30th May, and Saturday, 31st May 2025. The session commenced with an insightful address by the Principal, who provided a comprehensive overview of the curriculum and strategies for approaching the Board examinations. The session was further enriched by explaining the assessment pattern and showcasing a variety of classroom activities aimed at fostering the holistic development of students. The orientation offered parents a clear and engaging understanding of the school’s academic vision and student-centred approach.<br></br>

                                     <b>Higher Secondary School (Classes 9–12): </b> The orientation sessions for Classes 12 and 11 were held on 26th and 28th May, respectively. Recognizing the significant shift in academic rigour and expectations at this stage, the Principal took great care to guide both students and parents through the academic structure and highlighted the importance of this year in shaping their future pathways. In addition to academic focus, the Principal also emphasised the need to build strong values and character, underlining the importance of becoming individuals of integrity and purpose.<br></br>

                                     The orientation session concluded with an open forum where parents and students were encouraged to share their queries and concerns. All questions were addressed thoroughly by the Principal  ensuring clarity and reassurance. The session ended on a positive and collaborative note, setting a strong foundation for a successful academic year ahead.

                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ Orientation isn’t a formality—it’s the foundation on which confidence, connection, and clarity are built.”

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Orientation2025;